<template>
  <div id="finger" class="finger" v-if="show" v-on:mousemove="removeHand()">
    <img src="./../assets/grafinger2.svg" class="finger-icon">
    <img src="./../assets/choose.svg" class="choose-icon">
    <div class="years">
      <div class="year-fore">{{ datum['datum_fore'] }}</div>
      <div class="year-efter">{{ datum['datum_efter'] }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Finger',
  data () {
    return {
      show: true
    }
  },
  props: ['datum', 'canMove'],
  computed: {
  },
  methods: {
    removeHand () {
      console.log('moving over finger', this.canMove)
      if (this.canMove) {
        this.show = false
      }
    }
  },
  mounted () {
    let finger = document.getElementById('finger')
    finger.addEventListener('touchmove', (e) => {
      this.removeHand()
    })
  },
  components: {}
}
</script>

<style scoped>
  .finger {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 9999;
    flex-direction: column;
  }
  .finger-icon {
    height: 20%;
    display: block;
  }
  .choose-icon {
    height: 15%;
  }
  .years {
    color: #fff;
    position: absolute;
    bottom: 6%;
    background-color: rgba(0,0,0,0.2);
    padding: 2px 10px;
    font-size: 14px;
    left: 50%;
    transform: translateX(-50%);    
  }
  .years div {
    display: inline-block;
    padding: 2px 10px;
    letter-spacing: 1px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Finger.vue